export default "__VITE_ASSET__BkghJHXt__"